import React, { ReactElement } from 'react';
import { SlickSlider } from '@vw-marketing/us-components';
import { Review } from '../../typings/reviews';
import ReviewCard from '../../page/reviews-preview/review-card';
import {
  StyledModelCardWrapper,
  StyledFiveStarsCarouselContainer,
} from './styled';

interface FiveStarsCarouselProps {
  reviews: Review[];
  children: ReactElement;
  onHandleCarouselAction: (
    action: 'click' | 'swipe',
    direction: string,
  ) => void;
  onHandleCollapseTextAction: (state: boolean) => void;
}

export const FiveStarsCarousel: React.FC<FiveStarsCarouselProps> = (
  props,
): JSX.Element | null => {
  const {
    reviews,
    children,
    onHandleCarouselAction,
    onHandleCollapseTextAction,
  } = props;
  return (
    <StyledFiveStarsCarouselContainer>
      <StyledModelCardWrapper>{children}</StyledModelCardWrapper>
      <SlickSlider
        visibleCards={2.5}
        visibleCardOnTablet={2.5}
        onActionTrackingTrigger={onHandleCarouselAction}
        showArrows
      >
        {reviews.map((review: Review) => (
          <ReviewCard
            review={review}
            key={review.id}
            onHandleCollapseTextAction={onHandleCollapseTextAction}
          />
        ))}
      </SlickSlider>
    </StyledFiveStarsCarouselContainer>
  );
};
